module.exports = __webpack_public_path__ + "static/media/MegurimC.89a06ba2.png";